import { useEffect, useState } from "react";
import { Trophy } from "lucide-react";
import api, { eur } from "../../lib/api";
import { Table, TableHeader, TableRow, TableHead, TableBody, TableCell } from "../ui/table";

export default function ReferralLeaderboard() {
  const [rows, setRows] = useState([]);
  useEffect(() => { api.get("/admin/referrals").then(({ data }) => setRows(data)).catch(() => {}); }, []);
  return (
    <div className="bg-white rounded-2xl border border-stone-200 p-6" data-testid="referral-leaderboard">
      <h3 className="font-serif text-xl font-semibold text-[#0B2A45] flex items-center gap-2 mb-1"><Trophy className="w-5 h-5 text-[#EAB308]" />Classifica "Porta un amico"</h3>
      <p className="text-sm text-stone-500 mb-4">Clienti che hanno portato più amici paganti: premiali con un regalo extra.</p>
      {rows.length === 0 ? <p className="text-sm text-stone-400" data-testid="referral-leaderboard-empty">Nessun ordine con codice amico finora.</p> : (
        <Table>
          <TableHeader><TableRow><TableHead>#</TableHead><TableHead>Cliente</TableHead><TableHead>Codice</TableHead><TableHead className="text-right">Amici paganti</TableHead><TableHead className="text-right">In attesa</TableHead><TableHead className="text-right">Fatturato amici</TableHead><TableHead className="text-right">Premi ricevuti</TableHead></TableRow></TableHeader>
          <TableBody>
            {rows.map((r, i) => (
              <TableRow key={r.code} data-testid={`referral-row-${r.code}`}>
                <TableCell className="font-mono text-stone-400">{i + 1}</TableCell>
                <TableCell><div className="font-medium text-[#0B2A45]">{r.name}</div><div className="text-xs text-stone-400">{r.email}</div></TableCell>
                <TableCell className="font-mono text-xs">{r.code}</TableCell>
                <TableCell className="text-right font-semibold">{r.friends_paid}</TableCell>
                <TableCell className="text-right text-stone-500">{r.friends_pending}</TableCell>
                <TableCell className="text-right font-mono">{eur(r.revenue)}</TableCell>
                <TableCell className="text-right">{r.rewards}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      )}
    </div>
  );
}
